export const DATA_SOURCE_TYPES = {
  POWER_BI: 1,
  GOOGLE_SHEETS: 2
}

export const DATA_SOURCE_MENU_ACTIONS = {
  POWER_BI: 'power-bi',
  GOOGLE_SHEETS: 'google-sheets',
  REQUEST_INTEGRATION: 'request-integration'
}

export const DATA_SOURCE_MENU_GROUPS = {
  USER_DATA_SOURCES: 'user-data-sources'
}

export const DATA_SOURCE_QUERY_NAME_MAX_LENGTH = 100

export const DATA_SOURCE_SETUP_GUIDE_LINK =
  'https://oboard.atlassian.net/wiki/spaces/OBPFJ/pages/2333802497'

export const DATA_SOURCE_INTEGRATION_HELP_LINK =
  'https://oboard.atlassian.net/servicedesk/customer/portal/2/group/2/create/11?summary=Request+for+new+data+source&description=I+would+like+to+request+integration+with+data+SOURCE'
